import { render, staticRenderFns } from "./ProcessCategoryAdd.vue?vue&type=template&id=64d9ba3c&"
import script from "./ProcessCategoryAdd.vue?vue&type=script&lang=js&"
export * from "./ProcessCategoryAdd.vue?vue&type=script&lang=js&"
import style0 from "./ProcessCategoryAdd.vue?vue&type=style&index=0&id=64d9ba3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports